<template>
	<div class="pa-5">
		<v-list dense >
			<v-subheader>{{name}}</v-subheader>
			<v-list-item-group v-model="current" v-for="(item, i) in items" :key="i" >
					<FolderListItem v-if="item.type == 'folder'" :allowUpload="allowUpload" :item="item" :home="folder"></FolderListItem>
					<FileListItem v-if="item.type == 'file'" :allowUpload="allowUpload" :item="item" :home="folder" v-on:deleted="fileDeleted" v-on:addMeta="showMeta"></FileListItem>
			</v-list-item-group>
		</v-list>
		
		<UploadField label="Upload new document" v-if="allowUpload" :folderStem="folder" :folderPaths="folders" :exists="false" v-on:complete="newFile"></UploadField>
		<v-dialog width="600" v-model="dialog">
			<FileMeta v-if="focus" :exists="true" :filePath="focus.location.path_" v-on:complete="dialog = false"></FileMeta>
		</v-dialog>
	</div>
	
</template>
<script>
	import Vuex from "vuex"
	import {listFiles} from "../../assets/storageFunctions.js";
	export default {
		name: "StorageList",
		props: {
			allowUpload: { type: Boolean },
			folder: {type: String },
			folders: {type: Array, default: () => [] },
			name: {type: String, default: 'Documents'}
		},
		data: () => {
			return {
				dialog: false,
				items: [], 
				current: false,
				focus: false,
			}
		},
		components: {
			UploadField: () => import("../tools/UploadField"),
			FolderListItem: () => import('../tools/FolderListItem'),
			FileListItem: () => import('../tools/FileListItem'),
			FileMeta: () => import('../tools/FileMeta'),
		},
		computed:{
			...Vuex.mapState({
				user: state => state.auth.user
			})
		},
		created(){
			const self = this;
			if(!self.folder){ return; }
			listFiles("/" + self.folder).then( a =>  {
				a.prefixes.forEach( p => {
					p.type = "folder";
					self.items.push(p)
				} );
				a.items.forEach( i => {
					i.type = "file";
					self.items.push( i )
				})
			})
		}, 
		methods:{
			showMeta(file){
				this.focus = file;
				this.dialog = true;
			},
			newFile(file){
				var obj = {type: "file", location: file.ref.location};
				if( ! (this.current && this.current.type == 'folder') ){
					this.items.push( obj )
				}
			}, 
			fileDeleted( item ){
				this.items.splice( this.items.indexOf(item), 1 )
			}
		}
	}
</script>